export default [
  {
    path: '/b/dokumen-inventarisasi',
    redirect: '/b/dokumen-inventarisasi',
    name: 'bDokumenInventarisasi',
    component: () => import('@/views/NestedRoute.vue'),
    children: [
      {
        path: '',
        name: 'bDokumenInventarisasiIndex',
        component: () => import('@/views/b/dokumenInventarisasi/Index.vue'),
        meta: {
          action: 'Lihat',
          resource: 'b-dokumen-inventarisasi',
          pageTitle: 'Dokumen Inventarisasi',
          breadcrumb: [
            {
              text: 'Dokumen Inventarisasi',
              active: true,
            },
          ],
        },
      },
    ],
  },
]
